"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var exactPath = function (handler, opts) {
    return function (req, next) {
        if (req.basePath === req.path || (opts && opts.allowTrailingSlash && req.path === req.basePath + "/")) {
            return handler(req, next);
        }
        next();
    };
};
exports.exactPath = exactPath;
